import { CartBundleOrderItem } from './CartItem';

// --- Types ---
export interface SelectedItemBase {
  name: string;
  quantity: number;
  price: number;
  tax: number;
  absorbFees: boolean;
  fee: number;
  feeTax: number;
  date?: string;
}

export const enum SelectedItemType {
  TICKET = 'ticket',
  ADDON = 'addon',
  TOPUP = 'topup',
  BUNDLE = 'bundle',
}

export interface SelectedTicket extends SelectedItemBase {
  type: SelectedItemType.TICKET;
  // should refactor to use id instead of ticketId
  ticketId: string;
  idOrderItem: string | undefined;
  timeStart?: string;
  timeEnd?: string;
}

export interface SelectedSeat extends SelectedTicket {
  seatId: string;
  seatLabel: string;
  subtypeId?: string;
}

export interface SelectedAddon extends SelectedItemBase {
  type: SelectedItemType.ADDON;
  // should refactor to use id instead of addonId
  addonId: string;
  ticketId: string;
  ticketIndex: number;
}

export interface SelectedTopup extends SelectedItemBase {
  type: SelectedItemType.TOPUP;
  ticketId: string;
  ticketIndex: number;
  idOrderItem: string;
  // absorbFees: false; -- should we enforce this?
}

export interface SelectedBundle extends SelectedItemBase {
  type: SelectedItemType.BUNDLE;
  id: string;
  orderItems: CartBundleOrderItem[];
}

export type SelectedItem =
  | SelectedTicket
  | SelectedSeat
  | SelectedAddon
  | SelectedTopup
  | SelectedBundle;

export type SelectedItems = SelectedItem[];

// --- Type Guards ---
export function isTicket(item: SelectedItem): item is SelectedTicket {
  return item.type === SelectedItemType.TICKET;
}

export function isSeat(item: SelectedItem): item is SelectedSeat {
  return item.type === SelectedItemType.TICKET && 'seatId' in item;
}

export function isAddon(item: SelectedItem): item is SelectedAddon {
  return item.type === SelectedItemType.ADDON;
}

export function isTopup(item: SelectedItem): item is SelectedTopup {
  return item.type === SelectedItemType.TOPUP;
}

export function isBundle(item: SelectedItem): item is SelectedBundle {
  return item.type === SelectedItemType.BUNDLE;
}
